// extracted by mini-css-extract-plugin
module.exports = {"viewport":"UtoAUfCmM4OBTZfzo6jACA=="};